import Button from '../../Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '../../dialogs/BaseDialog';
import InfoCard from '../../InfoCard';

type ConfirmDialogProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  renderTrigger?: () => React.ReactNode;
  contentProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
  loading?: boolean;
  error?: string;
} & React.ComponentPropsWithoutRef<typeof Dialog>;

export default function ConfirmDialog({
  children,
  title = 'Confirm Action',
  description,
  confirmText = 'OK',
  cancelText = 'Cancel',
  renderTrigger,
  onConfirm,
  onCancel,
  contentProps,
  loading,
  error,
  ...props
}: ConfirmDialogProps) {
  return (
    <Dialog {...props}>
      {!!renderTrigger && (
        <DialogTrigger asChild>{renderTrigger()}</DialogTrigger>
      )}
      <DialogContent {...contentProps}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {!!description && (
            <DialogDescription>{description}</DialogDescription>
          )}
        </DialogHeader>
        {children}
        {error && <InfoCard severity="error">{error}</InfoCard>}
        <DialogFooter>
          {onCancel ? (
            <Button
              loading={loading}
              colorScheme="secondary"
              onClick={onCancel}
              type="submit"
            >
              {cancelText}
            </Button>
          ) : (
            <DialogClose asChild>
              <Button loading={loading} colorScheme="secondary" type="submit">
                {cancelText}
              </Button>
            </DialogClose>
          )}
          {onConfirm ? (
            <Button loading={loading} onClick={onConfirm} type="submit">
              {confirmText}
            </Button>
          ) : (
            <DialogClose asChild>
              <Button loading={loading} type="submit">
                {confirmText}
              </Button>
            </DialogClose>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
